/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Verification_DescriptionInputs */

const en_delete_account_verification_description = /** @type {(inputs: Delete_Account_Verification_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please check your email and enter the special one-time verification code here.`)
};

const es_delete_account_verification_description = /** @type {(inputs: Delete_Account_Verification_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa tu correo electrónico e ingresa aquí el código especial de verificación de un solo uso.`)
};

const ar_delete_account_verification_description = /** @type {(inputs: Delete_Account_Verification_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يرجى التحقق من بريدك الإلكتروني وإدخال رمز التحقق الخاص لمرة واحدة هنا.`)
};

/**
* | output |
* | --- |
* | "Please check your email and enter the special one-time verification code here." |
*
* @param {Delete_Account_Verification_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_verification_description = /** @type {((inputs?: Delete_Account_Verification_DescriptionInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Verification_DescriptionInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_verification_description(inputs)
	if (locale === "es") return es_delete_account_verification_description(inputs)
	return ar_delete_account_verification_description(inputs)
});